class EventTypes {
    static DOMContentLoaded: string = "DOMContentLoaded";
    static click: string = "click";
}
export {  EventTypes }
